import React, { Component } from 'react';

import compose from 'recompose/compose';

// Material helpersimport { forwardRef } from 'react';
import { forwardRef } from 'react';
import MaterialTable from "material-table";
import AddBox from '@material-ui/icons/AddBox';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { withStyles } from '@material-ui/core/styles';
import withWidth from '@material-ui/core/withWidth';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import {getDataMaintenance} from '../../../services/getMaintenance'
import {updateMaintenance} from '../../../services/createMaintenance'
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import TextField from '@material-ui/core/TextField';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
// Component styles
import styles from '../History/styles';
import moment from 'moment'
import 'moment/locale/es'
moment.locale('es')

const tableIcons = {
  Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
  Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
  Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
  DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
  Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
  Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
  FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
  LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
  NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
  ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
  SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
  ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
  ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
};

class History extends Component {
    constructor(props) {
        //console.log('props periodical', props.params.match.params.objetivo_id)
        //console.log(sessionStorage.getItem("listaObjetivosOnline"))
        super(props);
        //this.myCallback = this.myCallback.bind(this);
        this.state = {
            load:true,
            begin:moment().subtract(6,'days'),
            listData:[],
            dialogOpen:false,
            row:{},
            dialogOpenMsg:false,
            msg:''
        }
    }

    componentDidMount() {
        this.getDataFromAPI();
      }
    handleCloseModal = event => {   
      this.setState({
          dialogOpen: false,  
      })
    };
    handleCloseModalMsg = event => {   
      this.setState({
          dialogOpenMsg: false,  
          msg:''
      })
    };
  
      getDataFromAPI(){
        let token = sessionStorage.getItem('key')
        let user = sessionStorage.getItem('user')
        let client = sessionStorage.getItem('client_id')
        const {begin}=this.state
        var date=begin.format('YYYY-MM-DD')
        getDataMaintenance(client, token, date, user, 1).then(data=>{
          try {
            this.processData(data)   
                    
          } catch (error) {
              this.setState({
                  dataError: true,
                  load: false
              });
          }
        })     
      }
      processData(data){
        var listObjectives=JSON.parse(sessionStorage.getItem("listaObjetivosOnline"))
        var NewData=[]
        var dict={}
        data.map(ele=>{
            var begin=moment(ele.fecha_inicio).format("YYYY-MM-DD HH:mm:SS")
            var final=moment(ele.fecha_termino).format("YYYY-MM-DD HH:mm:SS")
            dict={'id':ele.id,'user_id':ele.usuario_id,'user':ele.nombre,"begin":begin,"final":final,'comentario':ele.comentario,'estado':ele.estado,"titulo":ele.titulo}
            var strObj=""
            //console.log(ele)
            var dictOk=false
            ele.objetivos.map((obj, i)=>{
              //console.log(ele.objetivo_id[i])
              //console.log(listObjectives)
              if(listObjectives.filter(j=>j.objetivo_id==ele.objetivo_id[i]).length>0){
                dictOk=true
                if(i+1!==ele.objetivos.length){
                  strObj+=obj["nombre"]+', '
                }else{
                  strObj+=obj["nombre"]
                }
              }
              
            })
            dict["objetivos"]=strObj
            if(dictOk){
              NewData.push(dict) 
            }
            
        })
        NewData.sort(function (a, b) {
          return (moment(b.begin)-moment(a.begin));
        });
        this.setState({
          load: false,
          listData:NewData
        });
      }
    edit=(row)=>{
      this.setState({
        dialogOpen:true,
        row:row
      });
    }
    remove=(row)=>{
      let token = sessionStorage.getItem('key')
      let id_user = sessionStorage.getItem('user')
      if(parseInt(id_user)!==row.user_id){
        this.setState({
          dialogOpen:false,
          dialogOpenMsg:true,
          msg:'No es posible editar a otro Usuario'
        });
      }else{
        updateMaintenance(row.id, id_user, token, row.comentario, row.titulo, 'Cancelado').then(data=>{
          if(data===false){
            this.setState({
              dialogOpen:false,
              dialogOpenMsg:true,
              msg:'No fue posible llevar a cabo la modificacion'
            });
          }else{
            this.setState({
              dialogOpen:false,
              dialogOpenMsg:true,
              msg:'Cambio exitoso'
            });
          }
        })
      }
    }

    handleFieldChange = (field, value) => {
      const {row}=this.state
      row[field] = value;
      this.setState({
        row:row,
      })
    }

    handleSaved = async (value) => {
      const {row}=this.state
      //console.log(row)
      let token = sessionStorage.getItem('key')
      let id_user = sessionStorage.getItem('user')
      if(parseInt(id_user)!==row.user_id){
        this.setState({
          dialogOpen:false,
          dialogOpenMsg:true,
          msg:'No es posible editar a otro Usuario'
        });
      }else{
        updateMaintenance(row.id, id_user, token, row.comentario, row.titulo, null).then(data=>{
          if(data===false){
            this.setState({
              dialogOpen:false,
              dialogOpenMsg:true,
              msg:'No fue posible llevar a cabo la modificacion'
            });
          }else{
            this.setState({
              dialogOpen:false,
              dialogOpenMsg:true,
              msg:'Cambio exitoso',
            });
          }
        })
      }
      

      
    }
    render() {
        const {listData, load, dialogOpen, row, msg, dialogOpenMsg,classes}=this.state
        //console.log('period', this.props)
        if(load===true){
          return(
            <Card >
              <PerfectScrollbar>
                  <Typography
                      
                      variant="h5"
                      align="center">
                      <CircularProgress
                          variant="indeterminate"      
                          size={24}
                          thickness={4}                            
                      />
                      Cargando Información...
                      </Typography>
              </PerfectScrollbar>
            </Card>
          )
        }else{
          return (
            <Card >
              <Modal
                  aria-labelledby="simple-modal-title"
                  aria-describedby="simple-modal-description"
                  open={dialogOpenMsg}
                  onClose={this.handleCloseModalMsg}
                  style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                  }}
                  disableAutoFocus={true}
                  disableEnforceFocus={true}
                  closeAfterTransition
                  BackdropComponent={Backdrop}
                  BackdropProps={{
                      timeout: 500,
                  }}
              >                                    
                <Fade in={dialogOpenMsg}>
                  <Grid
                    container
                    spacing={1}
                    style={{backgroundColor:"white"}}
                  >
                    <Grid
                        item
                        xs={12}
                        sm={12}
                        md={12}
                        xl={12}
                        style={{textAlign:"center"}}
                    >
                      <Typography style={{color:"red"}}>{msg}</Typography>
                    </Grid>
                  </Grid>
                </Fade>
              </Modal>
                <MaterialTable
                    icons={tableIcons}
                    columns={[
                        { title: "Usuario", field: "user"/*,defaultGroupOrder: 0*/ },
                        { title: "Inicio mantenimiento", field: "begin"/*, type: "numeric"*/ },
                        { title: "Término mantenimiento", field: "final"/*, type: "numeric"*/},
                        { title: "Estado", field: "estado"/*, type: "numeric"*/},
                        { title: "Título", field: "titulo"/*, type: "numeric"*/},
                        { title: "Comentario", field: "comentario"/*, type: "numeric"*/},
                        {
                          title: "Objetivos",
                          field: "objetivos",
                        },
                    ]}
                    data={listData}
                    actions={[
                      {
                        icon: ()=><Edit/>,
                        tooltip: 'Editar mantenimiento',
                        onClick: (event, rowData) => this.edit( rowData)
                      },
                      {
                        icon: ()=><Remove/>,
                        tooltip: 'Eliminar mantenimiento',
                        onClick: (event, rowData) => this.remove( rowData)
                      }
                    ]}
                    title=""
                    localization={{
                        grouping: {
                            groupedBy: 'Agrupar por:',
                            placeholder: 'Arrastre los encabezados aquí, para agrupar',
                        },
                        body: {
                        emptyDataSourceMessage: 'No hay datos'
                        },
                        toolbar: {
                        searchTooltip: 'Buscar'
                        },
                        pagination: {
                        labelRowsSelect: 'Filas',
                        labelDisplayedRows: ' {from}-{to} de {count}',
                        firstTooltip: 'Pri. pág.',
                        previousTooltip: 'Pág. previa',
                        nextTooltip: 'Sig. pág.',
                        lastTooltip: 'Últ. pág'
                        },
                        header: {
                          actions: 'Acciones'
                        }
                    }}
                    options={{
                        grouping: true
                    }}
                >
                  
                </MaterialTable>
                <Modal
                  aria-labelledby="simple-modal-title"
                  aria-describedby="simple-modal-description"
                  open={dialogOpen}
                  onClose={this.handleCloseModal}
                  style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                  }}
                  disableAutoFocus={true}
                  disableEnforceFocus={true}
                  closeAfterTransition
                  BackdropComponent={Backdrop}
                  BackdropProps={{
                      timeout: 500,
                  }}
              >                                    
                  <Fade in={dialogOpen}>
                  <Grid
                      container
                      spacing={1}
                      style={{backgroundColor:"white"}}
                  >
                      <Grid style={{textAlign:"right"}} >
                          <IconButton style={{textAlign:"right",color:'black'}}   onClick={this.handleCloseModal}><CloseIcon/></IconButton>
                      </Grid>
                      <Grid
                          item
                          xs={12}
                          sm={12}
                          md={12}
                          xl={12}
                          style={{textAlign:"center"}}
                      >
                        <TextField
                          //helperText="Nombre"
                          label="nombre"
                          margin="dense"
                          onChange={event =>
                              this.handleFieldChange('name', event.target.value)
                          }
                          required
                          value={row.user}
                          disabled id="standard-disabled"
                          //variant="outlined"
                      />
                      </Grid>
                      <Grid
                          item
                          xs={12}
                          sm={12}
                          md={12}
                          xl={12}
                          style={{textAlign:"center"}}
                      >
                      <TextField
                          //helperText="Nombre"
                          label="inicio"
                          margin="dense"
                          onChange={event =>
                              this.handleFieldChange('begin', event.target.value)
                          }
                          required
                          value={row.begin}
                          disabled id="standard-disabled"
                          //variant="outlined"
                      />
                      </Grid>
                      <Grid
                          item
                          xs={12}
                          sm={12}
                          md={12}
                          xl={12}
                          style={{textAlign:"center"}}
                      >
                      <TextField
                          //helperText="Nombre"
                          label="termino"
                          margin="dense"
                          onChange={event =>
                              this.handleFieldChange('final', event.target.value)
                          }
                          required
                          value={row.final}
                          disabled id="standard-disabled"
                          //variant="outlined"
                      />
                      </Grid>
                      
                      <Grid
                          item
                          xs={12}
                          sm={12}
                          md={12}
                          xl={12}
                          style={{textAlign:"center"}}
                      >
                      <TextField
                          //helperText="Nombre"
                          label="titulo"
                          margin="dense"
                          onChange={event =>
                              this.handleFieldChange('titulo', event.target.value)
                          }
                          required
                          value={row.titulo}
                          //disabled id="standard-disabled"
                          //variant="outlined"
                      />
                      </Grid>
                      <Grid
                          item
                          xs={12}
                          sm={12}
                          md={12}
                          xl={12}
                          style={{textAlign:"center"}}
                      >
                      <TextField
                          //helperText="Nombre"
                          label="comentario"
                          margin="dense"
                          onChange={event =>
                              this.handleFieldChange('comentario', event.target.value)
                          }
                          required
                          value={row.comentario}
                          //disabled id="standard-disabled"
                          //variant="outlined"
                      />
                      </Grid>
                      <Grid
                          item
                          xs={12}
                          sm={12}
                          md={12}
                          xl={12}
                          style={{textAlign:"center"}}
                      >
                        <Button
                          onClick={this.handleSaved}
                          color="primary"
                          variant="contained"
                          
                        >
                            Guardar Mantenimiento
                        </Button>
                      </Grid>

                      

                    </Grid>
                </Fade>
              </Modal>    
            </Card>
              
          );
      }
    }
}


export default compose(withWidth(), withStyles(styles))(History);
